import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import { GenericComponent } from "../../components/generic.component";
import { UntypedFormControl, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { MatOptionSelectionChange } from "@angular/material/core";
import { CountryDTO } from "../../models/country-dto";
import { CountryService } from "@core/services/country.service";
import { HelperService } from "@core/services/helper.service";
import { CountryCodeEnum } from "@shared/enums";

@Component({
    selector: "app-smartfleet-country-auto-complete",
    templateUrl: "./country-auto-complete.component.html",
    styleUrls: ["./country-auto-complete.component.scss"],
    standalone: false
})
export class CountryAutoCompleteComponent
  extends GenericComponent
  implements OnInit
{
  _disabled = false;
  name = new UntypedFormControl();
  searchForm = this.fb.group({
    name: this.name
  });

  allCountries: CountryDTO[] = [];
  countries: CountryDTO[] = [];

  @Input() title = "";
  @Input() page = "";
  @Input() requiredText = "";
  @Input() required = false;
  @Input() set disabled(value: boolean) {
    this._disabled = value;
    if (value) {
      this.searchForm.disable();
    } else {
      this.searchForm.enable();
    }
  }
  @Input() defaultCountry?: CountryCodeEnum;

  @Output() onChange: any = new EventEmitter<CountryDTO>();

  constructor(
    private countryService: CountryService,
    private helperService: HelperService,
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit() {
    if (this.page != "") {
      let key;
      switch (this.page) {
        case "service-request":
          key = "srq-country";
          break;
        case "service-request-pending":
          key = "srp-country";
          break;
        case "scheduling-request":
          key = "sr-countryFilter";
          break;
        case "client-list":
          key = "cl-countryFilter";
          break;
        case "car-workshop":
          key = "cw-country";
          break;

        default:
          break;
      }
      //e coleta o filtro correspondente, se houver
      if (
        localStorage.getItem(key) != null &&
        localStorage.getItem(key) != ""
      ) {
        const country = JSON.parse(localStorage.getItem(key));
        this.searchForm.controls.name.setValue(country["name"]);
      }
    } else {
      this.clean();
    }

    this.listCountries();

    this.name.valueChanges.subscribe((value) => {
      if (value) {
        this.countries = this.allCountries.filter((item) =>
          this.helperService
            .normalizeWord(item.name)
            .includes(this.helperService.normalizeWord(value))
        );
      } else {
        this.countries = this.allCountries;
        this.onChange.emit({} as CountryDTO);
      }
    });
  }

  listCountries(): void {
    this.countryService
      .listAll()
      .pipe(first())
      .subscribe(
        (data) => {
          this.allCountries = data;
          this.countries = data;
        },
        () => {}
      );
  }

  handleCountryChange(event: MatOptionSelectionChange, country: CountryDTO) {
    if (event.isUserInput === true) {
      this.onChange.emit(country);
    }
  }

  clean(): void {
    this.searchForm.reset();
    this.countries = [];
  }

  setValue(value: string): void {
    this.searchForm.get("name").setValue(value);
    this.countries = [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['defaultCountry'] && this.defaultCountry) {
      const countryCopy = [...this.countries];
      const country = countryCopy.find((item)=>
      item.code === this.defaultCountry
      )
      this.searchForm.get('name')?.setValue(country.name.toUpperCase());  
      this.onChange.emit(country)
    }
  }
}
